module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[77]76.2bfec3e.woff2";